import React from "react";

export const CategoryCtaBlocks = ({content}) => {
    return (
        <div
            className="cta-blocks"
            dangerouslySetInnerHTML={{__html: content}}
        ></div>
    );
};
